import { Location as HistoryLocation } from "history";
import * as React from "react";
import { connect } from "react-redux";
import { Route, RouteProps } from "react-router";
import { push } from "react-router-redux";
import * as redux from "redux";
import { RedirectWithStatus } from "../../components/generic";
import { Paths } from "../../constants";
import { AppState } from "../../store";
import * as AuthHelper from "../../utils/AuthHelper";
import { DefaultConnectedDispatch, DefaultConnectedState, DefaultDispatchPropsMap, DefaultStatePropsMap } from "../base";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    ...DefaultStatePropsMap(state, ownProps),
    isAdminUser: AuthHelper.isAdminUser(state.auth.accessToken, state.auth.refreshToken),
    isLoggedIn: (state.auth.data)
        ? state.auth.data.hasUserRecord
        : false,
    url: state.router.location,
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...DefaultDispatchPropsMap(dispatch),
    redirectToLogin: (returnUrl: string) => {
        dispatch(push(Paths.Account.Login + returnUrl));
    },
});

type OwnProps = RouteProps & {
};

interface OwnState {
}

type ConnectedState = DefaultConnectedState & {
    isAdminUser: boolean;
    isLoggedIn: boolean;
    url: HistoryLocation | null;
};

type ConnectedDispatch = DefaultConnectedDispatch & {
    redirectToLogin: (returnUrl: string) => void;
};

interface OwnState {
}

export class AdminRouteComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public componentDidMount() {
        if (!this.props.isAdminUser)
            this.props.replace(Paths.AccessDenied + "?url=" + this.getEncodedPath());
    }

    public componentDidUpdate() {
        if (!this.props.isAdminUser)
            this.props.replace(Paths.AccessDenied + "?url=" + this.getEncodedPath());
    }

    public getRedirectUrl() {
        let redirectUrl = "";

        if (this.props.url) {
            const encodedReturnUrl = encodeURIComponent(decodeURIComponent((this.props.url.pathname + "") + (this.props.url.search + "") + (this.props.url.hash + "")));
            redirectUrl += "?returnUrl=" + encodedReturnUrl;
        }

        return redirectUrl;
    }

    public render() {
        if (!this.props.isLoggedIn)
            return <RedirectWithStatus to={Paths.Account.Login + this.getRedirectUrl()} />;

        // if (!this.props.isAdminUser)
        //     return <Route { ...this.props } render={(routeProps) => <AccessDenied />} />;

        return <Route { ...this.props } />;
    }

    private getEncodedPath() {
        if (this.props.url)
            return encodeURIComponent(decodeURIComponent((this.props.url.pathname + "") + (this.props.url.search + "") + (this.props.url.hash + "")));
        return "";
    }
}

export const AdminRoute: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(AdminRouteComponent);



// WEBPACK FOOTER //
// ./src/components/access/AdminRoute.tsx